import { useEffect, useMemo, useState } from "react";
import { MOSAIC_BY_CODE } from "@/data/mosaic";
import { districtGroupCount } from "@/lib/audienceEngine";

// Streams genuine district × profile counts from the dataset while the audience compiles.
export function DataTicker({ audience, running }) {
  const rows = useMemo(() => {
    const out = [];
    audience.areas.slice(0, 12).forEach((d) => {
      Object.keys(MOSAIC_BY_CODE).forEach((code) => {
        const n = districtGroupCount(d, code);
        if (n > 0) out.push({ id: `${d}-${code}`, d, code, name: MOSAIC_BY_CODE[code].name, n });
      });
    });
    return out;
  }, [audience.areas]);
  const [cursor, setCursor] = useState(0);

  useEffect(() => {
    if (!running || !rows.length) return undefined;
    const id = setInterval(() => setCursor((c) => c + 1), 95);
    return () => clearInterval(id);
  }, [running, rows.length]);

  const visible = rows.length ? Array.from({ length: Math.min(6, rows.length) }, (_, i) => rows[(cursor + i) % rows.length]) : [];

  return (
    <div className="h-[150px] overflow-hidden rounded-2xl border border-white/[0.07] bg-black/25 p-4 font-ui text-[11px]" aria-hidden="true" data-testid="compilation-ticker">
      {visible.map((r, i) => (
        <div key={`${r.id}-${cursor + i}`} className="flex items-center justify-between gap-3 py-[3px]" style={{ opacity: running ? 0.25 + (i / 6) * 0.75 : 0.25 }}>
          <span className="truncate text-white/70"><span className="text-[#C6EE5A]">{r.d}</span> · {r.code} {r.name}</span>
          <span className="num text-white/60">{r.n.toLocaleString("en-GB")}</span>
        </div>
      ))}
    </div>
  );
}
